<!-- MÓDULO SEGURO EDITABLE -->
<div class="module seguro">
  <h2>Seguro</h2>
  <form action="" [formGroup]="form">
    <div class="wrapperG4">
      @for (option of optionsInsuranceType; track option) {
        <div>
          <h3>{{ option.filterType.name }}</h3>
          @for (filter of option.filterType.filter; track filter) {
            <label class="checkboxWrapper">
              <input type="checkbox" formControlName="{{filter.formControlName}}" [value]="true"
                     (change)="onInsuranceTypeChange($event,filter.formControlName ,filter.value)"/>
              <span class="checkmark"></span>
              <span class="description">{{ filter.description }}</span>
            </label>
          }
        </div>
      }
    </div>
  </form>
</div>
